import React from 'react';
import Icon from '../Icon';

export default function ChartPlaceholder() {
  return (
    <div className="p-6">
      <p className="h-full flex items-center justify-center text-primary text-4xl sm:text-6xl lg:text-9xl">
        <Icon icon="FaChartBar" />
      </p>
    </div>
  );
}
